import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { getHttpErrorMessage } from "../card-orders/card-order.util";
import { ToastrService } from "./toastr.service";

@Injectable({
  providedIn: "root",
})
export class ToastrTranslatedService {
  constructor(
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
  ) {}

  success(translationKey: string, interpolateParams?: object): void {
    this.toastr.success(
      this.translate.instant(translationKey, interpolateParams) as string,
    );
  }

  warning(translationKey: string, interpolateParams?: object): void {
    this.toastr.warning(
      this.translate.instant(translationKey, interpolateParams) as string,
    );
  }

  error(translationKey: string, interpolateParams?: object): void {
    this.toastr.error(
      this.translate.instant(translationKey, interpolateParams) as string,
    );
  }

  apiError(
    error: unknown,
    fallbackKey: string,
    interpolateParams?: object,
  ): void {
    const message = getHttpErrorMessage(error);
    if (message) {
      this.toastr.error(message);
      return;
    }
    this.error(fallbackKey, interpolateParams);
  }
}
